import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Typography,
} from '@material-ui/core'

import AlertSubscriptionToggleContainer from '../controls/AlertSubscriptionToggleContainer'

class CommunityDetailsView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    community: PropTypes.object.isRequired,
  }

  static styles = () => ({
    subscription: {
      float: 'right',
    },
  })

  render() {
    const { classes, community } = this.props

    return (
      <>
        { community.id
          && <AlertSubscriptionToggleContainer className={classes.subscription} communityId={community.id} />}
        { community.name
          && <Typography variant="h6">{community.name}</Typography>}
        { (community.location && community.location.address)
          && <Typography variant="subtitle1">{community.location.address}</Typography>}
      </>
    )
  }
}

export default withStyles(CommunityDetailsView.styles)(CommunityDetailsView)
